import { useEffect, useState } from 'react'

const Careers = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://www.startupjobs.cz/front/web/components/embedding/embedding2.min.js'
    script.async = true

    document.body.appendChild(script)
    setIsLoading(false)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    !isLoading && (
      <iframe
        title={'StartupJobs.cz'}
        id="sj-offers-banner"
        src="https://www.startupjobs.cz/startup/fitify?embedded=1"
        width="100%"
      />
    )
  )
}

export default Careers
